import { Stack } from '@healthinal/ui';
import { createFileRoute } from '@tanstack/react-router';
import { useGetPersonByIdSuspense } from '../../../../api/generated/person-controller/person-controller.ts';
import { EditPersonForm } from '../components/EditPersonForm.tsx';

export const Route = createFileRoute('/masterdata/persons/$personId/')({
  component: RouteComponent,
  staticData: { title: 'Personalien' },
});

function RouteComponent() {
  const { personId } = Route.useParams();
  const { data: person } = useGetPersonByIdSuspense(personId);

  return (
    <Stack flex={1} gap={2}>
      <EditPersonForm person={person} />
    </Stack>
  );
}
